<div class="w-full max-w-[800px] px-4 sm:px-8 md:px-12 py-6 sm:py-8">

  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <div style="background: #dbeafe; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #2563eb; font-size: 24px; width: 24px; height: 24px;">edit_note</mat-icon>
    </div>
    <div>
      <h2 style="font-size: 1.25rem; font-weight: 700; color: #111827; margin: 0;">Editar transaccion</h2>
      <p style="font-size: 0.8rem; color: #6b7280; margin: 0;">
        ID #{{ transaccion.id }} - Solo podra editar beneficiario, DNI y cuenta
      </p>
    </div>
  </div>

  <!-- Formulario -->
  <form [formGroup]="datosForm" class="w-full" *ngIf="datosForm">

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Nombre</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">person</mat-icon>
        <input type="text" matInput formControlName="nombre" placeholder="Nombre del beneficiario">
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Apellidos</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">person</mat-icon>
        <input type="text" matInput formControlName="apellido" placeholder="Apellidos del beneficiario">
      </mat-form-field>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Tipo documento</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">badge</mat-icon>
        <mat-select required formControlName="tipoID">
          <mat-option>Tipo documento</mat-option>
          <mat-option *ngFor="let tipo of tiposID" [value]="tipo">
            {{ tipo }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Numero identificacion</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">fingerprint</mat-icon>
        <input type="text" matInput formControlName="numeroID" placeholder="Documento de identidad">
      </mat-form-field>
    </div>

    <div class="grid grid-cols-1 gap-4">
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Numero de cuenta</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
        <input type="text" matInput formControlName="numeroCuenta" placeholder="Maximo 20 caracteres">
      </mat-form-field>
    </div>

  </form>

  <!-- Botones -->
  <div class="flex flex-col sm:flex-row justify-center gap-3 sm:gap-6 w-full mt-6">
    <button type="button" (click)="updateTransaction()" [disabled]="datosForm?.invalid"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      [style.background-color]="datosForm?.valid ? '#1C593D' : '#d1d5db'"
      [style.color]="datosForm?.valid ? 'white' : '#9ca3af'"
      [style.cursor]="datosForm?.valid ? 'pointer' : 'not-allowed'"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; margin-right: 4px;">save</mat-icon>
      Guardar cambios
    </button>
    <button type="button" (click)="close()"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Cancelar
    </button>
  </div>

</div>
